<template>
  <el-table-column
    prop="from"
    sortable="custom"
    label="Érvényesség kezdete"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      {{ scope.row.from | date }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'from',
  };
</script>
